import { css } from 'styled-components';

export const scrollbarColoredMixin = (color: string) => css`
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${color};
    border-radius: 6px;
  }
`;
